/** Faz 8 — Umsatzbericht in der Android-App (F8-16), Deutsch. Mit einer Zeile in `mobile.de.ts` eingebunden (ADR-801). */
export const mobileFaz8De = {
  salesReport: {
    title: 'Umsatzbericht',
    open: 'Umsatzbericht öffnen',
    hint: 'Nettoumsatz, Bestellungen, durchschnittlicher Warenkorb, Neukunden',
    presets: {
      today: 'Heute',
      last_7: 'Letzte 7 Tage',
      this_month: 'Dieser Monat',
      last_month: 'Letzter Monat',
    },
    periodLabel: 'Zeitraum',
    netSales: 'Nettoumsatz',
    orders: 'Bestellungen',
    averageOrder: 'Durchschnittlicher Warenkorb',
    newCustomers: 'Neue Kunden',
    deductions: 'Rücksendungen und Stornierungen',
    itemsSold: 'Verkaufte Einheiten',
    vsPrevious: '{{change}} gegenüber dem Vorzeitraum',
    up: '{{pct}} % mehr',
    down: '{{pct}} % weniger',
    flat: 'unverändert',
    new: 'im Vorzeitraum keine',
    dailyTitle: 'Nach Tag',
    dailyRow: '{{orders}} Bestellungen',
    topProducts: 'Meistverkaufte Produkte',
    productRow: '{{quantity}} Einheiten',
    noSales: 'In diesem Zeitraum gibt es keine Verkäufe.',
    partial: 'Der Zeitraum ist noch nicht abgeschlossen; die heutigen Zahlen können sich noch ändern.',
    awaiting: '{{count}} Bestellungen warten auf Zahlung ({{amount}}) und zählen nicht als Umsatz.',
    fxMissing: '{{count}} Bestellungen in Fremdwährung ohne Wechselkurs wurden nicht berücksichtigt.',
    definition:
      'Bestätigte Bestellungen (bezahlt, in Bearbeitung, versendet, zugestellt, abgeschlossen); Beträge in TRY inkl. MwSt., nach Rücksendungen und Stornierungen. Gleiche Definition wie in der Verwaltung.',
    morePanel: 'Aufschlüsselungen, Dateien und der Finanzbericht befinden sich in der Verwaltung.',
    noPermission: 'Um Umsatzzahlen zu sehen, ist die Berechtigung „Umsatzberichte“ erforderlich.',
  },
};
